import { FC, useContext, useMemo } from 'react'
import {
  BACK_BUTTON_PROPS,
  PayCardAmountPaneButton,
  PayCardConfirmPaneButton,
  PayCardDatePaneButton,
  PayCardMethodPaneButton,
} from 'components/features/pfm/Button/FloatingPaneButtons'
import { SelectPaymentAmountFields } from 'components/features/creditCard/creditCardPanes/paneFormFields/SelectPaymentAmountFields'
import { useStoreSelector } from 'helpers/reactReduxHelpers'
import { createPaymentRequestSelector, currentCCLedgerSelector } from 'components/features/creditCard/creditCardStore/selectors'
import LoadingOverlay from 'components/atoms/preloaders/LoadingOverlay'
import { PaneContext } from 'components/features/pfm/FloatingPaneHost/FloatingPaneHost'
import Flex from 'components/atoms/Flex/Flex'
import { useFormContext } from 'react-hook-form'
import { CreditCardFloatingPane } from 'components/features/creditCard/creditCardStore/floatingPane'
import { CCCreateCardPaymentRequest } from 'components/features/creditCard/creditCardStore/types'

const PayCardAmountStep: FC<{}> = () => {
  const { watch } = useFormContext<CCCreateCardPaymentRequest>()
  const paymentMethod = watch('payment_method')
  const paymentRequest = useStoreSelector(createPaymentRequestSelector)
  const ledger = useStoreSelector(currentCCLedgerSelector)
  const pane = useContext(PaneContext) as CreditCardFloatingPane
  const isAutoPay = pane?.mode === 'autoPay'
  const isLoading = paymentRequest?.isLoading

  const backButton = useMemo(() => (
    <PayCardAmountPaneButton
      { ...BACK_BUTTON_PROPS }
      backButton={ pane?.backButton }
      disabled={ isLoading }
    />
  ), [isLoading, pane?.backButton])

  const PayNowButton = useMemo(() => !paymentMethod ? (
    <PayCardMethodPaneButton text='Pay Now' backButton={ backButton } />
  ) : (
    <PayCardConfirmPaneButton text='Pay Now' backButton={ backButton } />
  ), [paymentMethod, backButton])

  const PayLaterButton = useMemo(() => isAutoPay ? (
    <PayCardDatePaneButton text='Save Auto-pay Amount' />
  ) : (
    <PayCardDatePaneButton text='Pay Later' style='hollow' />
  ), [isAutoPay])

  if (!ledger) {
    return <LoadingOverlay />
  }

  return (
    <Flex padding='large-responsive'>
      <section>
        <h2>Select an amount</h2>
        <p>
          By paying your full current balance on time every month, you will be able to
          reduce your interest payments.
        </p>
      </section>
      <SelectPaymentAmountFields />
      <Flex>
        { !isAutoPay && PayNowButton }
        { PayLaterButton }
        <small>Payment received after 6PM PT will be submitted on the following business day. For payment days that fall on a weekend or holiday, payments will be submitted on the following business day.</small>
      </Flex>
    </Flex>
  )
}

export default PayCardAmountStep
